module.exports = __webpack_public_path__ + "images/zoom_landing_header.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/zoom_landing_header.jpg
// module id = 860
// module chunks = 3